module.exports = __webpack_public_path__ + "img/prota-avatar.f2b5406e.png";